import { useMemo, useEffect } from 'react';

import type { ComponentsVideoSectionItem } from 'queries/graphql';

import { usePreviewData } from 'utils/preview-data-context';
import { missingComponentField } from 'utils/error';

import styles from './styles.module.scss';

export default function VideoSectionItem({ placeholderImage, video }: ComponentsVideoSectionItem) {
  const { preview } = usePreviewData();

  useEffect(() => {
    if (!video) missingComponentField('video', 'video file', preview);

    if (!placeholderImage) missingComponentField('video', 'placeholder image', preview);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { videoSrc, placeholderSrc, type } = useMemo(
    () => ({
      videoSrc: video.src,
      placeholderSrc: placeholderImage.src,
      type: video?.mimetype,
    }),
    [video, placeholderImage]
  );

  return (
    <video className={styles.video} controls poster={placeholderSrc}>
      <source src={videoSrc} type={type} />
    </video>
  );
}
